import { render, staticRenderFns } from "./SearchTypeSelecter.vue?vue&type=template&id=018a70fa&scoped=true&"
import script from "./SearchTypeSelecter.vue?vue&type=script&lang=js&"
export * from "./SearchTypeSelecter.vue?vue&type=script&lang=js&"
import style0 from "./SearchTypeSelecter.vue?vue&type=style&index=0&id=018a70fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018a70fa",
  null
  
)

export default component.exports